import axios from "axios";
// import envData from "@/env.json";
import { message } from "antd";

const post = (url, params,config) => {
  // if(config){

  // }
  return axios.post(url, params,config);
};

const get = (url, params) => {
  return axios.get(url, {
    params
  });
};
axios.interceptors.request.use(
  (config) => {
    let token = window.localStorage.getItem("token")
    if (token) {
        config.headers.Authorization= 'Bearer '+token;    //将token放到请求头发送给服务器
    }
    return config;
  },
  err => {
    console.log(err);
    return Promise.reject(err);
  }
);
// const env = process.env.NODE_ENV;
// const HOST = process.env.REACT_APP_SECRET_API=='pro'?'http://api.prawards.com.cn/v1':'http://prapi.duocaishenghuo.cn/v1';
// const urlHOST = process.env.REACT_APP_SECRET_API=='pro'?'http://api.prawards.com.cn/':'http://prapi.duocaishenghuo.cn/'
// const previewHost =  process.env.REACT_APP_SECRET_API=='pro'?'http://casefile.prawards.com.cn':'http://filecase.duocaishenghuo.cn'
// const downloadHost =  process.env.REACT_APP_SECRET_API=='pro'?'http://api.prawards.com.cn/testFile':'http://prapi.duocaishenghuo.cn/testFile'
const HOST = 'http://api.prawards.com.cn/v1';
const urlHOST = 'http://api.prawards.com.cn/'
const previewHost =  'http://casefile.prawards.com.cn'
const downloadHost =  'http://api.prawards.com.cn/testFile'
// if (env === "production") {
  axios.defaults.baseURL = HOST; //服务器地址
// }

axios.interceptors.response.use(
  (response) => {
    const result = response.data || {}
    if(result.code !== 200){
      message.warn(result.message);
      return Promise.reject(result.data);
    }
    return Promise.resolve(result.data);
  },
  err => {
    console.log(err);
    return Promise.reject(err);
  }
);

export { post, get, HOST, urlHOST ,previewHost,downloadHost};
